import React from 'react';
import { Link } from 'react-router-dom';
import './SectionTitle.css';

/**
 * Reusable section title component with optional "View All" link
 * Used across HomePage, NewGraduatePage, and other pages
 */
const SectionTitle = ({ 
  title, 
  viewAllLink = null, 
  viewAllText = 'View All',
  className = '' 
}) => {
  return (
    <div className={`section-title-header ${className}`}>
      <h2 className="section-title">{title}</h2>
      {viewAllLink && (
        <Link to={viewAllLink} className="section-view-all-link">
          {viewAllText}
        </Link>
      )}
    </div>
  );
};

export default SectionTitle;
